import savings from '../../assets/images/illustrations/savings.svg';
import dataInput from '../../assets/images/illustrations/data-input.svg';
import messages from '../../assets/images/illustrations/messages.svg';
import postbox from '../../assets/images/illustrations/postbox.svg';
import security from '../../assets/images/illustrations/security.svg';
import settings from '../../assets/images/illustrations/settings.svg';

export default {
    namespaced: true,
    state: {
      benefits: [
        {
          id: 100,
          title: 'Zeit & Geld sparen',
          teaser: 'Sparen Sie sich den Gang zur Behörde und erledigen Sie Ihr Anliegen ganz ohne lästiges Warten, wann immer sie wollen. Hier haben wir immer geöffnet. Warum? Weil Zeit Geld ist!',
          description: `Sparen Sie sich den Gang zur Behörde und erledigen Sie Ihr Anliegen ganz ohne lästiges Warten, wann immer sie wollen. Hier haben wir immer geöffnet. Warum? Weil Zeit Geld ist!
          Ob Antrag, Auskunft oder digitale Leistung. Mit den E-Government-Angeboten der Stadt Augsburg können Sie bequem von zuhause oder mobil von unterwegs, 24 Stunden an sieben Tagen die Woche Ihre Behördengänge und Verwaltungsaufwände erledigen. 
          Das spart nicht nur Ihnen Zeit, sondern hilft auch Ihrer Stadt das Zeitalter der Digitalisierung in der öffentlichen Verwaltung einzuläuten. 
          E-Government ermöglicht es uns in Zukunft effizientere, strukturiertere und benutzerfreundlichere Dienstleistungen für den Bürger anzubieten.`,
          illustration: savings,
        },
        {
          id: 101,
          title: 'Einmalige Dateneingabe',
          teaser: 'Online arbeiten wir nach dem Once-Only-Prinzip, d.h. eine Eingabe Ihrer Daten ist nur einmal nötig. Für weitere Anliegen werden Ihre Daten dann behördenübegreifend gespeichert.',
          description: `Online arbeiten wir nach dem Once-Only-Prinzip, d.h. eine Eingabe Ihrer Daten ist nur einmal nötig. Für weitere Anliegen werden Ihe Daten dann behördenübegreifend gespeichert.
          Dazu verhilft Ihnen auch das Bürgerkonto. Dort werden Ihre Angaben verschlüsselt gespeichert und können bei neuen Anträgen und digitalen Formularen automatisiert übernommen werden. Das macht das Ausfüllen von Anträgen deutlich angenehmer und spart nicht nur Ihnen sondern auch der öffentlichen Verwaltung viel Zeit, Geld und Arbeit.
          Durch das behördenübergreifende Bereitstellen Ihrer Bürgerkonto-Daten, können zudem Folgeleistungen automatisiert, ohne Aufwand ihrerseits, bearbeitet werden (z.B. Kindergeld, Elterngeld, Kita-Warteliste).`,
          illustration: dataInput,
        },
        {
          id: 102,
          title: 'Ansprechpartner',
          teaser: 'Den einheitlichen Ansprechpartner, der Ihnen nach der Aktivierung Ihres Bürgerkontos zugeteilt wird, können Sie zu all Ihren Fragen und Anliegen rund um die öffentliche Verwaltung kontaktieren.',
          description: `Den einheitlichen Ansprechpartner (Point of Single Contact), der Ihnen nach der Aktivierung Ihres Bürgerkontos zugeteilt wird, können Sie zu all Ihren Fragen und Anliegen rund um die öffentliche Verwaltung kontaktieren.
          Das finden der richtigen Behörde oder der Verwaltungsleistung kann oftmals undurchschaubar wirken. Daher gibt es nun, ähnlich wie der PSC (Point of Single Contact) bei Unternehmen einen einheitlichen Ansprechpartner für unsere Augsburger BürgerInnen. Dieser wird Ihnen Auskunft über die erfoderlichen Schritte und Vorraussetzungen Ihres Anliegen, telefonisch oder per Chat geben. 
          Außerhalb der Geschäftszeiten erreichen Sie auch über die Behördennummer 115 einen kompetenten Ansprechpartner, der Ihnen bei Ihrem Anliegen unterstützen wird.`,
          illustration: messages,
        }
      ]
    },
    mutations: {

    },
    actions: {

    },
    getters: {
      getAllBenefits: state => {
        return state.benefits;
      },
      getBenefitsById: (state) => (id) => {
        return state.benefits.find(benefit => benefit.id == id)
      },
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/benefits.js